export default "__VITE_ASSET__znZnHve3__"